var Variants = {
	node :null,
	current: 2048,

	init: function() {
		Variants.node = $("<div id='variants'></div>");
		$("#overlay").append(Variants.node);

		AppEvent.on(player, "beforeLoad", function(pe) { 
			Variants.stopcycle();

			if (player.params['v'] != undefined) {
				player.variant = player.params['v']; player.params['v'] = undefined;
			} 
		});

		AppEvent.on(player, "placeReady", function(pe) { Variants.placeReady(pe);});
	},

	placeReady: function(pe) {

		if (player.current.place_type == "panorama") {
			if (player.current.properties.hide_variants != undefined && player.current.properties.hide_variants == "1") $("#variants").hide();
			else $("#variants").show();

			Variants.node.html("");
			//Variants.node.append(TPL.render("variants-main", {}));
			variants = {
				'spring': {'title': TPL.lng("html5.variants.spring", 'Wiosna'), 'has': false},
				'summer': {'title': TPL.lng("html5.variants.summer",'Lato'), 'has': false},
				'autumn': {'title': TPL.lng("html5.variants.autumn",'Jesień'), 'has': false},
				'winter': {'title': TPL.lng("html5.variants.winter",'Zima'), 'has': false},
				'summer2018' : {'title': TPL.lng("html5.variants.summer2018",'Lato 2018'), 'has': false},
				'winter2011' : {'title': TPL.lng("html5.variants.winter2011",'Zima 2011'), 'has': false},
				'after' : {'title': TPL.lng("html5.variants.after",'Po rewitalizacji'), 'has': false},
				'before': {'title': TPL.lng("html5.variants.before",'Przed rewitalizacją'), 'has': false},
				'day'   : {'title': TPL.lng("html5.variants.day",'Dzień'), 'has': false},
				'night' : {'title': TPL.lng("html5.variants.night",'Noc'), 'has': false},
				'v1' : {'title': TPL.lng("html5.variants.v1",'Wariant 1'), 'has': false},
				'v2' : {'title': TPL.lng("html5.variants.v2",'Wariant 2'), 'has': false},
				'v3' : {'title': TPL.lng("html5.variants.v3",'Wariant 3'), 'has': false},
				'v4' : {'title': TPL.lng("html5.variants.v4",'Wariant 4'), 'has': false},
				'v5' : {'title': TPL.lng("html5.variants.v5",'Wariant 5'), 'has': false},
				'v6' : {'title': TPL.lng("html5.variants.v6",'Wariant 6'), 'has': false},
				'v7' : {'title': TPL.lng("html5.variants.v7",'Wariant 7'), 'has': false},
				'v8' : {'title': TPL.lng("html5.variants.v8",'Wariant 8'), 'has': false},
			};

			//console.log(TPL.lng("html5.variants.spring", "costam"));

			if (player.current.variants != undefined) {
				variants[player.current.variants.variant_main].has = true;

				for(var n in player.current.variants.items) {
					variants[player.current.variants.items[n].type].has = true;
					if (player.current.variants.items[n].ident != undefined) variants[player.current.variants.items[n].type].ident = player.current.variants.items[n].ident;
				}

				var active = "";

				for(var v in variants) {
					active = "";
					if (player.variant == v || (player.variant == null && v == player.current.variants.variant_main)) active = "active";
					if (variants[v].has) Variants.node.append($("<a href='javascript:void(null);' class='variant_option speaks " + active + "' onclick='Variants.switch(\"" + v + "\", " + variants[v].ident + ")' data-speak='" + variants[v].title + "'  title='Zmień wersję panoramy na: " + variants[v].title + "'>" + variants[v].title + "</a>"));
				}

				SpeechManager.enableSpeech("#variants", ".speaks", 0, "TOPMENU");

				if (player.current.properties.autocycle != undefined && player.current.properties.autocycle != "") {
					Variants.auto(JSON.parse(player.current.properties.autocycle), true);
				}
			}

			Variants.ident = player.ident;
		} else {
			$("#variants").hide();
		}
	},

	switch: function(type, ident, fast, speed) {
		player.turn_to = null;
		var rx = player.currentView.renderer.rx;// + player.currentView.renderer.disort.x;
		var ry = player.currentView.renderer.ry;// + player.currentView.renderer.disort.y;

		HotSpotManager.setTransition(undefined);

		if (ident != undefined) {
			player.load(ident, (rx - 90 + 4) + "," + (ry * -1));
		} else if (fast) {
			player.currentView.loadSpots = false;
			if (player.currentView != undefined && player.currentView.clear  != undefined) player.currentView.clear();
			if (player.currentView != undefined && player.currentView != null && player.currentView.beforeLeave != null) player.currentView.beforeLeave();

			player.variant = type;

			player.currentView.leaving();
			player.lastView = player.currentView;
			player.current.loadSpots = false;
			player.current.showLoading = false;
			player.currentView = new panoramaView(player.ident, player.current, player.half, player.turn_to);
//			player.currentView.loadSpots = false;

			if (speed != undefined) {
				player.currentView.renderer.opacityStep = speed;
			}

			player.currentView.renderer.rx = player.lastView.renderer.rx;
			player.currentView.renderer.ry = player.lastView.renderer.ry;

			if (player.currentView != null) player.currentView.load();		
		} else {
			player.variant = type;
			player.load(player.ident, (rx - 90 + 4) + "," + (ry * -1));
		}
	},

	auto: function($prog, loop) {
		Variants.program = $prog;
		Variants.progloop = loop;
		Variants.progindex = 0;

		Variants.autocycle();
	},

	autocycle: function() {
		var speed;
		if (Variants.program[Variants.progindex].speed != undefined) {
			speed = Variants.program[Variants.progindex].speed * 0.04;
		}
		Variants.switch(Variants.program[Variants.progindex].var, null, true, speed);

		Variants.progindex ++;

		if (Variants.progindex > Variants.program.length - 1) {
			if (Variants.progloop) Variants.progindex = 0;
			else return;
		}

		Variants.timeout = setTimeout(function() {
			Variants.autocycle();
		}, Variants.program[Variants.progindex].delay);
	},

	stopcycle: function() {
		if (Variants.timeout != undefined) {
			clearTimeout(Variants.timeout);
			Variants.timeout = undefined;

			/*
			if (Variants.ident != player.ident && player.lastView != undefined) {
				player.lastView.loadSpots = true;
				player.lastView.clear();
			}
			*/
		}
	}
}

PluginManager.add(Variants);